import React, {useEffect} from 'react'

import {logOutUser} from 'utils/user'
import useUserContext from 'components/User/useUserContext'

const Logout = () => {
  const {setUser} = useUserContext()

  useEffect(() => {
    logOutUser(setUser)
  }, [setUser])

  return (
    <div>
      logged out
    </div>
  )
}

export default Logout
